import { render, staticRenderFns } from "./DeliveryAddress.vue?vue&type=template&id=2641cf27&"
import script from "./DeliveryAddress.vue?vue&type=script&lang=js&"
export * from "./DeliveryAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardText,VCardTitle,VCheckbox,VCol,VOverlay,VProgressCircular,VRow,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Projects\\Markomat-Client\\eLpass\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2641cf27')) {
      api.createRecord('2641cf27', component.options)
    } else {
      api.reload('2641cf27', component.options)
    }
    module.hot.accept("./DeliveryAddress.vue?vue&type=template&id=2641cf27&", function () {
      api.rerender('2641cf27', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Checkout/DeliveryAddress.vue"
export default component.exports